/**
 * Get the costing text of the get cost
 * @param {*} roomInfo
 */
export default function getCostingText(roomInfo = [], hideRoomText = false) {
	let roomCounts,
		adultCounts = 0,
		childCounts = 0
	roomCounts = roomInfo.length
	roomInfo.forEach(cost => {
		adultCounts += cost.adultCount
		childCounts += (cost.childAges || []).length
		//babyCounts += (cost.childAges || []).filter(baby => baby >= 1).length;
	})
	const costingText =
		adultCounts +
		' adult' +
		(adultCounts > 1 ? 's' : '') +
		(childCounts
			? ' & ' + childCounts + (childCounts > 1 ? ' children' : ' child') + ', '
			: hideRoomText
			? ''
			: ', ') +
		`${
			hideRoomText
				? ''
				: roomCounts +
				  // getNumberToWord(roomCounts) +
				  ' room' +
				  (roomCounts > 1 ? 's' : '')
		}`
	return costingText
}
/**
 * Used to find the travel type based on costing configuration
 */
export const getTravelType = (
	roomInfo = [
		{
			adultCount: 2,
			childAges: [],
		},
	],
) => {
	let roomCounts,
		adultCounts = 0,
		babyCounts = 0
	roomCounts = roomInfo.length
	roomInfo.forEach(cost => {
		adultCounts += cost.adultCount
		babyCounts += (cost.childAges || []).length
	})
	if (adultCounts === 1 && babyCounts === 0) {
		return 'SOLO'
	} else if (adultCounts === 2 && roomCounts === 1 && babyCounts === 0) {
		return 'COUPLE'
	} else if (adultCounts >= 1 && babyCounts) {
		return 'FAMILY'
	} else {
		return 'FRIENDS'
	}
}

export const getCostingBasedOntype = type => {
	switch (type) {
		case 'PARTNER':
		case 'COUPLE':
			return [{ adultCount: 2, childAges: [] }]
		case 'FRIENDS':
			return [{ adultCount: 3, childAges: [] }]
		case 'FAMILY':
			return [{ adultCount: 2, childAges: [] }]
		case 'SOLO':
			return [{ adultCount: 1, childAges: [] }]
		default:
			return [{ adultCount: 2, childAges: [] }]
	}
}

export const getStayTypes = () => {
	return [
		{
			text: '3 Nights',
			value: 3,
			name: '3 nights',
		},
		{
			text: '4 Nights',
			value: 4,
			name: '4 nights',
			// flagText: 'Ideal for Maldives'
		},
		{
			text: '5 Nights',
			value: 5,
			name: '5 nights',
		},
		{
			text: '6 Nights',
			value: 6,
			name: '6 nights',
		},
	]
}

export const getPaxTypes = () => {
	return [
		{
			text: '❤️ Couple',
			value: 'COUPLE',
			costingConfigText: '2 adults, 1 room',
			name: 'Couple',
		},
		{
			text: '👪 Family',
			value: 'FAMILY',
			costingConfigText: '',
			name: 'Family',
		},
		{
			text: '🎉 Friends',
			value: 'FRIENDS',
			costingConfigText: '',
			name: 'Friends',
		},
		{
			text: '😎 Solo',
			value: 'SOLO',
			costingConfigText: '1 adult, 1 room',
			name: 'Solo',
		},
	]
}

export const getDubaiPaxTypes = () => {
	return [
		{
			text: '❤️ Partner',
			value: 'COUPLE',
			costingConfigText: '2 adults, 1 room',
			name: 'Partner',
			trackerClass: 'n-tracker-dubai-pax-type-partner',
		},
		{
			text: '👪 Family',
			value: 'FAMILY',
			costingConfigText: '',
			name: 'Family',
			trackerClass: 'n-tracker-dubai-pax-type-family',
		},
		{
			text: '🎉 Friends',
			value: 'FRIENDS',
			costingConfigText: '',
			name: 'Friends',
			trackerClass: 'n-tracker-dubai-pax-type-friends',
		},
		{
			text: '😎 Going solo',
			value: 'SOLO',
			costingConfigText: '1 adult, 1 room',
			name: 'Going solo',
			trackerClass: 'n-tracker-dubai-pax-type-solo',
		},
	]
}
